
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/smart-chains/api/cclib",
      function () {
        return require("private-next-pages/docs/smart-chains/api/cclib/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/smart-chains/api/cclib"])
      });
    }
  